<template>
    <div class="borrow-success">
        <div class="success-msg">
            <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="43" cy="43" r="43" fill="white"/>
                <circle cx="43" cy="43" r="43" fill="#58B469"/>
                <path d="M22.4258 46.5774L37.2496 61.4013C37.6401 61.7918 38.2733 61.7918 38.6638 61.4013L67.2362 32.8289" stroke="#FEFEFE" stroke-width="6" stroke-linecap="round"/>
            </svg>
            <h1>{{ $t('m.rentalSuccessTitle') }}</h1>
            <h2 v-html="replaceTranslateContent($t('m.rentalSuccessSubtitle'))"/>
            <div v-active-touch class="primary-btn detail-btn" @click="$router.push('/renting_page')">
                {{ $t('m.orderDeatil') }}
            </div>
        </div>
    </div>
</template>

<script>
import {queryBorrowStatus} from "../../api/logined";

export default {
    name: "BorrowSuccess",
    data() {
        return {
            brandName: this.$store.getters['appConfig/brand_name'],
        }
    },
    created() {
        this.queryBorrowStatus()
    },
    methods: {
        queryBorrowStatus() {
            queryBorrowStatus().then(res => {
                // 更新仓库租借状态
                let isBorrow = parseInt(res.data.is_borrow)
                this.$store.dispatch('setIsBorrow', isBorrow)
                // 根据租借状态判断跳走还是显示成功信息
                if (!isBorrow) {
                    this.$router.push({name: 'landing_page'})
                }
                if (isBorrow) {
                    // 更新仓库订单信息
                    this.$store.dispatch('setOrderInfo', res.data.order)
                } else {
                    this.$router.push({name: 'order_info'})
                }
            }).catch(() => {
                this.$router.push({name: 'landing_page'})
            })
        },
    }
};
</script>

<style lang="scss">
    .success-msg {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        svg {
            width: 86px;
        }
        h1 {
            margin: 0;
            font-family: Sarala;
            font-size: 26px;
            font-weight: 700;
            line-height: 31.2px;
            margin-top: 20px;
            margin-bottom: 15px;
        }
        h2 {
            margin: 0;
            width: 283px;
            font-size: 14px;
            font-weight: 400;
            line-height: 20.16px;
            color: #333333;
            text-align: center;
        }
        .detail-btn {
            margin-top: 20px;
            background: #FFF;
            color: #333333;
            border: 0.5px solid #E6E6E6;
            border-radius: 6px;
        }
    }
</style>
